/**
 * Constantes para el módulo de Control Semanal
 */

// Mapeo de estados a colores para badges
export const STATE_COLORS = {
  delivered: 'success',
  not_delivered: 'danger',
  on_route: 'warning',
  Recepcionado: 'info',
  'Sin estado': 'dark'
};

// Mapeo de estados a etiquetas en español
export const STATE_LABELS = {
  delivered: 'Entregado',
  not_delivered: 'No Entregado',
  on_route: 'En Ruta',
  Recepcionado: 'Recepcionado',
  'Sin estado': 'Sin Estado'
};

// Colores para el gráfico de barras
export const CHART_COLORS = {
  delivered: '#28a745',
  not_delivered: '#dc3545',
  on_route: '#ffc107',
  Recepcionado: '#17a2b8',
  'Sin estado': '#6c757d'
};

// Niveles de confianza para reconciliación
export const CONFIDENCE_LEVELS = {
  exact: { label: 'Exacta', color: 'success' },
  high: { label: 'Alta', color: 'warning' },
  low: { label: 'Baja', color: 'secondary' }
};

// Offset de zona horaria para Chile
export const CHILE_TIMEZONE_OFFSET = -4 * 60; // UTC-4 en minutos

// Formatos de Excel disponibles
export const EXCEL_FORMATS = {
  TIPO_MANIFIESTO: 'tipo_manifiesto',
  INFORMATIVO: 'informativo'
};

// Configuración de paginación por defecto
export const DEFAULT_PAGE_SIZE = 100;
export const DEFAULT_PAGE_NUMBER = 1;
